"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENAME_ACCOUNT_COPY = exports.REFRESH_BANK_COPY = void 0;
/**
 * AN-61 / AN-62 (Anthony's batch, 9 Oct; web and mobile, rule 17, agreed 2026-10-12):
 * the two Connected Banks actions as visible words, on both apps.
 * - Refresh: a visible text button in each bank's header (was icon-only or hidden).
 * - Rename: "Edit means rename; make that obvious" (was an icon-only pencil).
 */
exports.REFRESH_BANK_COPY = "Refresh";
exports.RENAME_ACCOUNT_COPY = "Rename";
//# sourceMappingURL=bankActionsCopy.js.map